module.exports = __webpack_public_path__ + "media/images/integrated-payments-5-18125b3199e1e850bd12bcca1f970040.svg";